/** From Flutter `app_lv.arb` — privacyPolicy* / termsOfService*. */
export const legalMessagesLv = {
  privacy: {
    pageTitle: "Privātuma politika",
    lastUpdated: "Pēdējoreiz atjaunināts: 2026. gada 1. jūnijs",
    introduction: {
      title: "Ievads",
      body: "WasOK ir lokāla iepirkšanās palīglīdzekļa lietotne, kas palīdz lietotājiem atcerēties produktus, kurus viņi iepriekš ir iegādājušies, vērtējuši vai par kuriem atstājuši atsauksmes.\n\nŠī Privātuma politika skaidro, kāda informācija tiek apstrādāta, lietojot lietotni, kā dati tiek glabāti un kā var darboties noteikti trešo pušu pakalpojumi.",
    },
    dataStored: {
      title: "Lietotnes glabātie dati",
      body: "WasOK lokāli jūsu ierīcē glabā šādu informāciju:\n\n• noskenētos produktu svītrkodus\n• lietotāja ievadītos produktu nosaukumus un detaļas\n• vērtējumus un komentārus\n• iepirkumu sarakstus\n• produktu kategorijas\n• cenas un informāciju par veikaliem\n• produktu un veikalu fotoattēlus\n\nJūsu produktu dati un fotoattēli netiek augšupielādēti WasOK serveros.",
    },
    permissions: {
      title: "Izmantotās atļaujas",
      camera: {
        title: "Kamera",
        body: "Piekļuve kamerai tiek izmantota:\n\n• svītrkodu skenēšanai\n• produktu fotoattēlu uzņemšanai",
      },
      photos: {
        title: "Fotoattēli un multivide",
        body: "Piekļuve fotoattēliem vai galerijai tiek izmantota tikai tad, kad:\n\n• pievienojat attēlus produktiem\n• atjaunojat dublējumus, kuros ir fotoattēli",
      },
      files: {
        title: "Piekļuve failiem un krātuvei",
        body: "Piekļuve failiem var tikt izmantota:\n\n• dublējumu failu eksportēšanai\n• lietotāja izvēlētu dublējumu importēšanai\n• iepirkumu sarakstu vai dublējumu kopīgošanai",
      },
    },
    backup: {
      title: "Dublēšana un eksports",
      body: "WasOK ļauj izveidot dublējumu failus ar lietotnes datiem un pēc izvēles fotoattēliem.\n\nDublējumu faili tiek izveidoti lokāli jūsu ierīcē un var tikt saglabāti vai kopīgoti, izmantojot jūsu izvēlētos pakalpojumus, piemēram:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• lokālo ierīces krātuvi\n\nWasOK neaugšupielādē dublējumus savos serveros.",
      onlineProductLookup: {
        title: "Tiešsaistes produktu meklēšana",
        body: "Ja iestatījumos ieslēdzat tiešsaistes svītrkoda meklēšanu, WasOK var nosūtīt tikai noskenētā svītrkoda numuru uz publiskām datubāzēm (piemēram, Open Food Facts), lai ieteiktu nosaukumu un zīmolu. WasOK neaugšupielādē vērtējumus, komentārus, fotoattēlus, iepirkumu sarakstus, kategorijas, veikalu informāciju vai dublējumus. To var izslēgt jebkurā brīdī iestatījumos.",
      },
    },
    advertising: {
      title: "Reklāma un trešo pušu pakalpojumi",
      intro:
        "WasOK izmanto atlasītus trešo pušu pakalpojumus, lai nodrošinātu noteiktas funkcijas.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob tiek izmantots, lai rādītu reklāmas lietotnē.\n\nGoogle un tās partneri var apstrādāt informāciju, piemēram:\n\n• reklāmas identifikatorus\n• informāciju par ierīci\n• IP adresi\n• diagnostikas un lietojuma informāciju\n\nNoteiktos reģionos lietotājiem var tikt lūgts sniegt piekrišanu pirms personalizētu reklāmu rādīšanas.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK izmanto Firebase Crashlytics, lai palīdzētu identificēt avārijas un uzlabot lietotnes stabilitāti.\n\nAvāriju pārskatos var būt iekļauta tehniska informācija, piemēram:\n\n• ierīces modelis\n• operētājsistēmas versija\n• lietotnes versija\n• avāriju diagnostika\n\nAvāriju pārskatos apzināti netiek iekļauti jūsu produktu vērtējumi, piezīmes, iepirkumu saraksti vai fotoattēli.",
      },
      externalProductDatabases: {
        title: "Ārējās produktu datubāzes",
        body: "Svītrkoda meklēšanas funkcionalitāte var izmantot ārējas produktu datubāzes, lai iegūtu informāciju par produktu.\n\nPlašākai informācijai skatiet attiecīgo pakalpojumu sniedzēju privātuma politikas.",
      },
    },
    dataSecurity: {
      title: "Datu drošība",
      body: "WasOK glabā lietotnes datus lokāli jūsu ierīcē, izmantojot operētājsistēmas nodrošinātus glabāšanas mehānismus.\n\nLai gan tiek veikti saprātīgi pasākumi, lai aizsargātu lokālos lietotnes datus, neviena elektroniskā glabāšanas metode nav pilnībā droša.\n\nLietotāji paši ir atbildīgi par svarīgu datu dublējumu uzturēšanu, ja viņi to vēlas.",
    },
    children: {
      title: "Bērnu privātums",
      body: "WasOK nav paredzēts bērniem, kas jaunāki par 13 gadiem.",
    },
    notifications: {
      title: "Paziņojumi",
      body: "WasOK pēc izvēles var izveidot lokālus paziņojumus jūsu ierīcē, lai atgādinātu vērtēt produktus pēc pirkuma.\n\nŠie paziņojumi tiek ģenerēti un plānoti lokāli jūsu ierīcē un neprasa kontu vai attālinātu serveri.\n\nJūs varat jebkurā laikā atspējot paziņojumus ierīces iestatījumos vai lietotnē, ja tas tiek atbalstīts.",
    },
    yourControl: {
      title: "Jūsu kontrole pār datiem",
      body: "Jūs varat:\n\n• jebkurā laikā rediģēt vai dzēst saglabātos produktus\n• notīrīt lietotnes datus ierīcē\n• atinstalēt lietotni\n• eksportēt savu datu dublējumus",
    },
    changes: {
      title: "Izmaiņas šajā politikā",
      body: "Šī Privātuma politika laiku pa laikam var tikt atjaunināta.\n\nIzmaiņas stājas spēkā, kad tiek publicēta atjauninātā versija.",
    },
    contact: {
      title: "Kontakti",
      body: "Ja jums ir jautājumi par šo Privātuma politiku, lūdzu, sazinieties:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Pakalpojumu noteikumi",
    lastUpdated: "Pēdējoreiz atjaunināts: 2026. gada 1. jūnijs",
    acceptance: {
      title: "Noteikumu pieņemšana",
      body: "Lejupielādējot, instalējot vai izmantojot WasOK, jūs piekrītat šiem Pakalpojumu noteikumiem.\n\nJa nepiekrītat šiem Noteikumiem, nelietojiet lietotni.",
    },
    license: {
      title: "Licence",
      body: "WasOK piešķir jums ierobežotu, neekskluzīvu, nenododamu, atsaucamu licenci lietot lietotni saskaņā ar šiem Noteikumiem.",
    },
    acceptableUse: {
      title: "Pieņemama lietošana",
      body: "Jūs piekrītat ne:\n\n• ļaunprātīgi izmantot lietotni\n• traucēt lietotnes darbību\n• mēģināt veikt reversās inženierijas vai modificēt lietotni\n• izmantot lietotni, pārkāpjot piemērojamos likumus vai noteikumus",
    },
    localData: {
      title: "Lokālie dati un dublējumi",
      body: "WasOK glabā lietotāja datus lokāli ierīcē.\n\nLietotāji paši ir atbildīgi par svarīgu datu dublējumu uzturēšanu, ja viņi to vēlas.\n\nLai gan var būt pieejama dublēšanas un atjaunošanas funkcionalitāte, WasOK negarantē pret saglabāto datu zudumu, bojājumiem vai kļūmēm.",
    },
    advertisements: {
      title: "Reklāmas",
      body: "Lietotnē var tikt rādītas reklāmas, ko nodrošina trešo pušu reklāmas partneri, tostarp Google AdMob.",
    },
    noWarranty: {
      title: "Bez garantijas",
      body: "WasOK tiek nodrošināts \"tāds, kāds tas ir\" un \"kā pieejams\" bez jebkādām tiešām vai netiešām garantijām.\n\nMēs negarantējam, ka:\n\n• lietotne vienmēr būs pieejama\n• lietotne būs bez kļūdām\n• datu zudums nekad nenotiks\n• visas funkcijas darbosies nepārtraukti visās ierīcēs",
    },
    limitationLiability: {
      title: "Atbildības ierobežojums",
      body: "Maksimālajā likumā atļautajā mērā WasOK un tās izstrādātāji nav atbildīgi par:\n\n• datu zudumu\n• peļņas zudumu\n• ierīces problēmām\n• netiešiem vai izrietošiem zaudējumiem\n• pārtraukumiem, kas rodas lietošanas vai nespējas lietot lietotni dēļ",
    },
    thirdParty: {
      title: "Trešo pušu pakalpojumi",
      body: "Noteiktas funkcijas vai saturs var balstīties uz trešo pušu pakalpojumiem, tostarp reklāmas nodrošinātājiem un ārējiem glabāšanas/kopīgošanas pakalpojumiem, ko izvēlas lietotājs.\n\nWasOK nav atbildīga par trešo pušu pakalpojumiem vai to politikām.",
    },
    productInformation: {
      title: "Informācija par produktu",
      body: "Noteikta produkta informācija var tikt iegūta no trešo pušu svītrkoda meklēšanas pakalpojumiem.\n\nWasOK negarantē ārējo datu avotu sniegtās informācijas precizitāti, pilnīgumu, pieejamību vai piemērotību.\n\nLietotājiem, ja nepieciešams, pašiem jāpārbauda produkta informācija.",
    },
    changesApp: {
      title: "Izmaiņas lietotnē",
      body: "WasOK var tikt mainīts, atjaunināts, apturēts vai pārtraukts jebkurā laikā bez iepriekšēja paziņojuma.",
    },
    changesTerms: {
      title: "Izmaiņas šajos Noteikumos",
      body: "Šie Noteikumi laiku pa laikam var tikt atjaunināti.\n\nTurpinot lietot lietotni pēc atjauninājumu stāšanās spēkā, jūs piekrītat pārskatītajiem Noteikumiem.",
    },
    contact: {
      title: "Kontakti",
      body: "Ja jums ir jautājumi par šiem Noteikumiem, sazinieties:\n\nsupport@wasok.app",
    },
  },
};
